module.exports = __webpack_public_path__ + "img/Metastasis-LICA_PLC.0b5f381f.png";